import * as tslib_1 from "tslib";
import { View } from '@swim/ui';
var GeometryView = (function (_super) {
    tslib_1.__extends(GeometryView, _super);
    function GeometryView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return GeometryView;
}(View));
export { GeometryView };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VvbWV0cnktdmlldy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImdlb21ldHJ5LXZpZXcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sRUFBQyxJQUFJLEVBQUMsTUFBTSxVQUFVLENBQUM7QUFHOUI7SUFBMkMsd0NBQUk7SUFBL0M7O0lBRUEsQ0FBQztJQUFELG1CQUFDO0FBQUQsQ0FBQyxBQUZELENBQTJDLElBQUksR0FFOUMifQ==